<template>
<section id="infoGetLoan">
  <h2 class="instH2">Как быстро получить заём?</h2>
  <div id="infoGetLoanMainWrap">
    <div id="infoGetloanWrapPc">
      <div class="infoGetLoanItem">
        <p>Отправьте заявку →</p>
        <p>Оставьте заявку на сайте или<br>звоните нам по тел.<a :href="phoneForHref">{{phone}}</a></p>
        <p>1</p>
      </div>
      <div class="infoGetLoanItem">
        <p>Дождитесь рассмотрения</p>
        <p>Ваша заявка рассматривается<br>нашей системой</p>
        <p>2</p>
      </div>
      <div class="infoGetLoanItem">
        <p>Не пропустите звонок</p>
        <p>В случае одобрения вам позвонит<br>менеджер и договорится о времени<br>получения денег</p>
        <p>3</p>
      </div>
      <div class="infoGetLoanItem">
        <p>Встреча с агентом</p>
        <p>Наш агент оформит<br>все документы</p>
        <p>4</p>
      </div>
    </div>
    <div class="infoGetLoanItem last">
      <p>Получите деньги</p>
      <p>Деньги<br class="brinfoGetLoanPC"> поступят<br class="brinfoGetLoanPC"> на ваш<br>банковский<br class="brinfoGetLoanPC"> счет после<br class="brinfoGetLoanPC"> подписания<br>договора</p>
      <p>5</p>
    </div>
  </div>
</section>
</template>

<script>
export default {
  name: "infoGetLoan",
  props:{
    phone:{
      type:String,
      default(){
        return '';
      }
    },
    phoneForHref:{
      type:String,
      default(){
        return '';
      }
    },
  },
}
</script>

<style scoped>
#infoGetLoan{}
#infoGetLoanMainWrap{background: white; padding: var(--font-size-30) var(--font-size-21);border-radius: var(--font-size-20);font-family: 'Roboto';}
.infoGetLoanItem{background: var(--color-gray-type4);border-radius: var(--font-size-20);margin-bottom: var(--font-size-20); padding: var(--font-size-20) 0 0 var(--font-size-40);position: relative;color:var(--color-black-type2);min-height: var(--font-size-100)}
.infoGetLoanItem.last{margin: 0;background: var(--color-green);color:white;}
#infoGetLoan ul li p{}
.infoGetLoanItem p a{color:var(--color-black-type2);text-decoration: none;}
.infoGetLoanItem p:nth-child(1){font-size: var(--font-size-18);font-weight: 500;margin-bottom: var(--font-size-10)}
.infoGetLoanItem p:nth-child(2){font-size: var(--font-size-16);font-weight: 100;}
.infoGetLoanItem p:nth-child(3){font-size: var(--font-size-124);color:white;font-family: 'Ubuntu';font-weight: bold;position: absolute;bottom: calc(-1 * var(--font-size-26));right:var(--font-size-14)}
.brinfoGetLoanPC{display: none}
@media screen and (min-width: 760px) {

  .brinfoGetLoanPC{display: inline-block}
  #infoGetLoan{}
  #infoGetLoanMainWrap{padding: var(--font-size-60) var(--font-size-60) var(--font-size-37);display: flex;align-items: flex-start;justify-content: space-between}
  .infoGetLoanItem{width: var(--font-size-360);margin-bottom: var(--font-size-40);}
  .infoGetLoanItem.last{padding: var(--font-size-18) 0 0 var(--font-size-20);width: var(--font-size-140);min-height: var(--font-size-260)}
  #infoGetLoan ul li p{}
  .infoGetLoanItem p a{}
  .infoGetLoanItem p:nth-child(1){}
  .infoGetLoanItem p:nth-child(2){}
  .infoGetLoanItem p:nth-child(3){right:var(--font-size-10)}
  #infoGetloanWrapPc{display: flex;align-items: flex-start;justify-content: space-between;flex-wrap: wrap;width: var(--font-size-840)}
}
</style>